import React, { useState, useEffect } from 'react';
import SearchableSelect from './SearchableSelect';
import weighingService from '@/services/weighing';

interface DestinationSectionProps {
  formData: {
    destination: string;
    magasin: string;
    numeroLot: string;
  };
  onInputChange: (field: string, value: any) => void;
}

const DestinationSection: React.FC<DestinationSectionProps> = ({ formData, onInputChange }) => {
  const [magasins, setMagasins] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  // Charger les magasins au montage du composant
  useEffect(() => {
    loadMagasins();
  }, []);

  const loadMagasins = async () => {
    setLoading(true);
    try {
      const response = await weighingService.getMagasins();
      if (response && response.results) {
        setMagasins(response.results || []);
      }
    } catch (error) {
      console.log('Magasins non disponibles:', error);
      setMagasins([]);
    } finally {
      setLoading(false);
    }
  };

  // Convertir les données en format pour SearchableSelect
  const magasinOptions = magasins.map(m => ({
    value: m.id.toString(),
    label: `${m.nom} - ${m.adresse || 'Adresse non renseignée'}`
  }));

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-4">
      <h3 className="font-medium text-green-900 text-sm mb-3">DESTINATION / STOCKAGE</h3>
      
      <div className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-green-800 mb-1">Destination</label>
          <input
            type="text"
            value={formData.destination}
            onChange={(e) => onInputChange('destination', e.target.value)}
            placeholder="Lieu de destination"
            className="w-full px-3 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm bg-white"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-green-800 mb-1">Magasin</label>
          <SearchableSelect
            value={formData.magasin || ''}
            onChange={(value) => onInputChange('magasin', value)}
            options={magasinOptions}
            placeholder={loading ? "Chargement..." : "Sélectionner un magasin"}
            className="w-full"
            disabled={loading}
          />
          {loading && (
            <div className="mt-2 flex items-center text-sm text-gray-500">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-green-500 mr-2"></div>
              Chargement des magasins...
            </div>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-green-800 mb-1">N° Lot</label>
          <input
            type="text"
            value={formData.numeroLot}
            onChange={(e) => onInputChange('numeroLot', e.target.value)}
            placeholder="Numéro de lot"
            className="w-full px-3 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm bg-white"
          />
        </div>
      </div>
    </div>
  );
};

export default DestinationSection;
